import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { FC, useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as SystemInfoIcon } from '../../../assets/images/system-info-wrapper.svg';
import TitleGrid from '../../../components/grid/TitleGrid';
import BreadCrumb from '../../../components/title-page/BreadCrumb';
import TitlePage from '../../../components/title-page/TitlePage';
import { VesselContext } from '../../../context/vesselContext';
import { SystemInfoTemplateContext } from '../../../context/systemInfoTemplateContext';
import TemplateBox from '../../form-templates/TemplateBox';
import SystemInfoForm, { SystemInfoFormHandle } from './SystemInfoForm';
import LoadTemplateDialog from '../../../components/dialog/LoadTemplateDialog';
import paths from '../../../utils/constants/paths';
import { defaultPagination } from '../../../utils/constants/defaults';
import { SystemInfoTemplateInterface } from '../../../utils/types/systemInfoTemplate';

const SystemInfoList: FC = () => {
  const systemInfoFormRef = useRef<SystemInfoFormHandle>(null);
  const [openLoadTemplateDialog, setOpenLoadTemplateDialog] = useState(false);

  const { state: vesselState } = useContext(VesselContext);
  const { listSystemInfoTemplates, state: templatesState } = useContext(SystemInfoTemplateContext);

  useEffect(() => {
    listSystemInfoTemplates({
      ...defaultPagination,
      perPage: 100,
      attributes: ['id', 'name', 'createdAt', 'updatedAt']
    });
  }, []);

  const handleSaveClick = () => {
    systemInfoFormRef.current?.handleSave();
  };

  const handleClose = (_event: unknown, reason: 'escapeKeyDown' | 'backdropClick') => {
    if (reason === 'backdropClick') setOpenLoadTemplateDialog(false);
  };

  const handleSelectTemplate = (template: SystemInfoTemplateInterface) => {
    setOpenLoadTemplateDialog(false);
    systemInfoFormRef.current?.applyTemplate(template);
  };

  return (
    <>
      <TitlePage
        leftContainer={
          <BreadCrumb previous={vesselState.view.data?.name || 'Vessel'} current={'System Info'} />
        }
        rightContainer={
          <Button variant="outlined" onClick={() => setOpenLoadTemplateDialog(true)}>
            Load from template
          </Button>
        }
      />
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        style={{ marginTop: '71px', marginBottom: '49px' }}>
        <TemplateBox height={'calc(100vh - 240px)'}>
          <>
            <Grid display={'flex'} justifyContent={'space-between'}>
              <TitleGrid icon={<SystemInfoIcon className="icon-title" />} title={'System Info'} />
              <Button variant="contained" onClick={handleSaveClick}>
                Save
              </Button>
            </Grid>

            <SystemInfoForm ref={systemInfoFormRef} />
          </>
        </TemplateBox>
      </Grid>

      {openLoadTemplateDialog && (
        <LoadTemplateDialog
          list={templatesState?.list?.data?.results || []}
          open={openLoadTemplateDialog}
          createTemplatePath={paths.TEMPLATE_SYSTEM_INFO_FORM.absolutePath}
          onClose={handleClose}
          onLoad={handleSelectTemplate}
        />
      )}
    </>
  );
};

export default SystemInfoList;
